"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrameInterval = exports.FrameIntervalMode = void 0;
var FrameIntervalMode;
(function (FrameIntervalMode) {
    FrameIntervalMode[FrameIntervalMode["Playing"] = 0] = "Playing";
    FrameIntervalMode[FrameIntervalMode["Stopped"] = 1] = "Stopped";
})(FrameIntervalMode = exports.FrameIntervalMode || (exports.FrameIntervalMode = {}));
var FrameInterval = /** @class */ (function () {
    function FrameInterval(fps, callback) {
        this.callback = callback;
        this.fps = fps;
        this.delay = 1000 / fps; // Time per frame
        this.frame = -1;
        this.time = null;
        this.ref = null;
        this.mode = FrameIntervalMode.Stopped;
    }
    FrameInterval.prototype.setFps = function (nextFps) {
        this.fps = nextFps;
        this.delay = 1000 / nextFps;
        this.frame = -1;
        this.time = null;
    };
    FrameInterval.prototype.tick = function (time) {
        var _this = this;
        if (this.time === null) {
            this.time = time; // Initialize start time
        }
        var currentFrame = Math.floor((time - this.time) / this.delay);
        // Should move to next frame?
        if (currentFrame > this.frame) {
            this.frame = currentFrame;
            this.callback({ time: time, frame: this.frame });
        }
        this.ref = requestAnimationFrame(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.tick.apply(_this, args);
        });
    };
    FrameInterval.prototype.start = function () {
        var _this = this;
        if (this.mode === FrameIntervalMode.Stopped) {
            this.mode = FrameIntervalMode.Playing;
            this.ref = requestAnimationFrame(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _this.tick.apply(_this, args);
            });
        }
    };
    FrameInterval.prototype.stop = function () {
        if (this.mode === FrameIntervalMode.Playing && this.ref) {
            cancelAnimationFrame(this.ref);
            this.mode = FrameIntervalMode.Stopped;
            this.time = null;
            this.frame = -1;
        }
    };
    return FrameInterval;
}());
exports.FrameInterval = FrameInterval;
//# sourceMappingURL=FrameInterval.js.map